/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { useCallback, useEffect, useState } from 'react';

export const useTimeZonePickerPopover = (initialState: boolean) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(initialState);
  return { isPopoverOpen, setIsPopoverOpen };
};

export const useKeyboardNavigation = (optionsLength: number) => {
  const [focusedIndex, setFocusedIndex] = useState(0);

  useEffect(() => {
    setFocusedIndex(0);
  }, [optionsLength]);

  const handleArrowNavigation = useCallback(
    (key: string) => {
      if (key === 'ArrowDown') {
        setFocusedIndex((prevIndex) => {
          const newIndex = (prevIndex + 1) % optionsLength;
          return newIndex;
        });
      } else if (key === 'ArrowUp') {
        setFocusedIndex((prevIndex) => {
          const newIndex = (prevIndex - 1 + optionsLength) % optionsLength;
          return newIndex;
        });
      }
    },
    [optionsLength],
  );

  return { focusedIndex, handleArrowNavigation, setFocusedIndex };
};
